var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliverylocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C7.31286 0 3.5 3.768 3.5 8.4C3.5 14.7 12 24 12 24C12 24 20.5 14.7 20.5 8.4C20.5 3.768 16.6871 0 12 0ZM12 2.4C12.319 2.39992 12.6349 2.46194 12.9297 2.58251C13.2244 2.70307 13.4922 2.87983 13.7179 3.1027C13.9435 3.32556 14.1225 3.59015 14.2446 3.88138C14.3668 4.1726 14.4297 4.48475 14.4298 4.8C14.4299 5.11525 14.3671 5.42743 14.2451 5.71872C14.1231 6.01 13.9442 6.27468 13.7187 6.49766C13.4932 6.72063 13.2255 6.89752 12.9308 7.01824C12.6361 7.13895 12.3202 7.20112 12.0012 7.2012C11.357 7.20136 10.739 6.94859 10.2833 6.49851C9.82767 6.04842 9.57159 5.43788 9.57143 4.8012C9.57127 4.16452 9.82704 3.55386 10.2825 3.10354C10.7379 2.65323 11.3557 2.40016 12 2.4ZM12 14.4C9.97214 14.4 8.18714 13.38 7.14286 11.82C7.16714 10.236 10.385 9.36 12 9.36C13.615 9.36 16.8329 10.236 16.8571 11.82C16.3275 12.6143 15.6063 13.266 14.7584 13.7164C13.9105 14.1668 12.9626 14.4017 12 14.4Z",
    fill: "#2C2C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliverylocation);
export default __webpack_public_path__ + "static/media/deliverylocation.b356c609dd0f7282f3f2ac0ffe3e38b4.svg";
export { ForwardRef as ReactComponent };